import communications from '@/communications'

export default {
  install(app) {
    app.config.globalProperties.$coms = communications
  }
}